export default __webpack_public_path__ + "943e7f4026b4b85f0f6996691f38c0f4.png";